/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_Shopping_RemoveInputs */

const en_recipe_shopping_remove = /** @type {(inputs: Recipe_Shopping_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take off the list`)
};

const de_recipe_shopping_remove = /** @type {(inputs: Recipe_Shopping_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von der Liste nehmen`)
};

/**
* | output |
* | --- |
* | "Take off the list" |
*
* @param {Recipe_Shopping_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_shopping_remove = /** @type {((inputs?: Recipe_Shopping_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_Shopping_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_shopping_remove(inputs)
	return en_recipe_shopping_remove(inputs)
});